export default {"src":"/uk/_next/static/media/black-rock.7e379d1f.svg","height":20,"width":140,"blurWidth":0,"blurHeight":0};